import { __decorate } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
let CommonBack = class CommonBack extends Vue {
};
CommonBack = __decorate([
    Component
], CommonBack);
export default CommonBack;
